module.exports = __webpack_public_path__ + "img/plan-silver.99f07469.svg";